var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<inv-container retailer-id=\"{{$ctrl.customer.id}}\" mode=\"creditmemo\" customer-id=\"{{$ctrl.customer.id}}\" disable-query-string=\"true\"></inv-container>";
var id1="cust-details.creditmemos.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;